import React, { useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import {  Row, Col } from 'react-flexbox-grid'
import { Card, Form, Icon, Image, Message, Divider, Loader } from 'semantic-ui-react'
import Logo from '../../images/logo-admin.png'
import { backendService } from '../../services/backendService'
import { useHistory } from 'react-router-dom'
import { Text, Translate, LanguageContext } from '../../helpers/language';
import { doTokenLogin } from '../../actions/actionCreators'

const Restore = (props) => {
  const languageContext = useContext(LanguageContext);
  const history = useHistory();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false); 
  const [ message, setMessage ] = useState(null);
  const {id, token} = props.match.params;
  
  const [ verifying, setVerifying] = useState(false);

  const handleSubmit = async () => {      
      try {
        const response = await backendService.put(`/api/lawyers/${id}/verify`, { token: token });        
        if( response.data.success === true ) {
          setMessage(Translate(languageContext, response.data.message));
          setLoading(false);
          setTimeout( 
            () => props.dispatch( doTokenLogin({id, token})).then( () => {              
            history.push('/');
            })
          , 3000 );
          
          
        } else if (response.data.message) {
          setError(true);
          setMessage(Translate(languageContext, response.data.message));
          setLoading(false);
        } 
      }
      catch(error){
        setError(true);
        setMessage(Translate(languageContext, 'generic_fail_message'));
        setLoading(false);
      }     
  }
  
  
  if (!verifying) {
    setVerifying(true);
    setLoading(true);
    handleSubmit();
  }

  return (
    <div className="lisia-dialog lisia-centered-dialog">
        <Row center="xs">
          <Col className='email-confirm-dialog-wrapper' xs={11} sm={9} md={7} lg={3}>
            <Card fluid={true} raised={true} centered={true}>
              <Card.Content>
                <div className="emailConfirmForm">                    
                  <Image size='small' src={Logo} className='m-b-10 lisia-logo'/>                    
                  <Form>
                    <h3 className='text-center'><Text tid='verify_email_title' /></h3>
                    <Divider />                                  
                      <Form.Field>
                          <Message icon>
                            <Icon className={error ? 'warning sign' : 'info sign'} />
                            <Message.Content>
                            { !message ?  
                              <Text tid="loading" /> :
                              message
                            }
                            </Message.Content>
                          </Message>
                      </Form.Field>                      
                    <div className='footer'>                    
                      <Link to='/' style={{float: 'left'}}>
                          <Text tid="back" />
                      </Link>
                    </div>
                  </Form>
                </div>
              </Card.Content>
            </Card>
          </Col>
        </Row>
    </div>
  )
}

Restore.propTypes = {

}

const mapStateToProps = (state) => ({
  auth: state.auth,
})

export default connect(mapStateToProps)(Restore)